import React, { useEffect, useState } from 'react'
import Partial from "../myExpertUn/myExpert.js"
import Sidebar from "../../../../components/dashboard/institute/sidebar/sidebar.js";

import asktheexpertdashboard from "../../../../assets/images/asktheexpertdashboard.svg";
import { useHistory } from "react-router-dom";
import { Trans, useTranslation } from 'react-i18next';
import "../myExpert/myExpert.model.css"
import { Footer } from '../../../common/footer/footer';
import myexpertbg from "../../../../assets/Instituteppvimages/myexpertbg.svg";
import { ExpertListCardJSX } from '../../../common/expertListCard/expertListCard';
import { Pagination } from '../../../common/pagination/uiPagination.js';

const MyExpertJsx = (props) => {
  const history = useHistory();
  const { t } = useTranslation();


  const {
    expertData,
    activeTab,
    onTabClick,
    onPaginationButtonClick,
    page
  } = props;
  const itemsPerPage = 10

  const [currentPage] = useState(1);

  const currentItems = expertData?.slice(
    (page - 1) * itemsPerPage,
    page * itemsPerPage
  );

  const loginData = JSON.parse(localStorage.getItem('loginData'));



  const getInstitutionName = () => {
    let tempArr = [];

    expertData?.forEach(cat => {
      tempArr.push(cat?.slugUrl);
    });

    localStorage.setItem("slugSet", tempArr.join());
  };

  useEffect(() => {
    getInstitutionName()
  });

  const planType = localStorage.getItem("planName")
  const addAnotherExpert = () => {
    let token = localStorage.getItem("token")
    localStorage.setItem('AdminFlow', 'expert')
    localStorage.setItem("instituteExpertToken", token)
    localStorage.setItem("instituteExpert", true)
    localStorage.setItem("adInsExpert", true)
    localStorage.setItem("comingFromInstitute", true)
    history.push("/expertRegistration");
  }
  return (
    <>
      <>
        {  activeTab === 'acntStng' ?
          <section className="main_institute_dashboard">
            <section className="entiredashboard maincustomerdash main institute_dashboard">
              <div className="container-fluid">
                <div className="row dashboard-decoration">
                  <div className="col-lg-4 col-sm-4">
                    <Sidebar />
                  </div>
                  <div className="col-lg-8 col-sm-8 dashboard-data-exp">
                    <div className="dashboardrightpannerinnerleft dashboardrightpanel">
                   
                      <h2 className="h2_style font-weight-600 d-block d-lg-none d-sm-none d-md-none"><span className="headingicon d-block d-lg-none d-sm-none d-md-none "><img alt="article" src={asktheexpertdashboard} /></span>{t("instituteExpertrs.HEADING")}</h2>
                         <div className="p-0 mb-4">
                            <p className="dahsboardTitle d-none d-sm-block">{t("instituteExpertrs.HEADING")}</p>
                            <p className="dahsboardSubTitle"> <Trans i18nKey="instituteExpertrs.SUBHEADING" ></Trans> </p>
                         </div>                     
                     
                      <div className="add-expert">
                      <div className="row">
                        <div className="col-lg-6 add-expert-data">
                          <h3 className="add-expert-title">{t("instituteExpertrs.ADDEXPERT")}</h3>
                          <p className="add-expert-subtitle">{t("instituteExpertrs.ADDEXPERTTITLE")}</p>
                          <p className="add-expert-limit">{t("instituteExpertrs.ADDEXPERTLIMIT")} {loginData?.totalExpertsLimit} </p>
                          <div className="addexpertright">
                            {planType && planType === "Premium" ? <button type="button" className="add-expert-button" onClick={addAnotherExpert} >{t("instituteExpertrs.ADDEXPERTBUTTON")}</button>
                              :
                              <button type="button" className="add-expert-button" onClick={addAnotherExpert} >{t("instituteExpertrs.ADDEXPERTBUTTON")}</button>

                            }
                          </div>
                        </div>
                        <div className="col-lg-6 add-expert-img">
                          <img src={myexpertbg} alt={'Add'} />
                        </div>
                      </div>
</div>
                      <div className="myexpert-nav">
                        <p className="registered-experts col-6">{t("instituteExpertrs.REGEXPERTS")}</p>
                        <p className="partially-registered col-6" onClick={() => onTabClick('partial')}>{t("instituteExpertrs.PARREGEXPERTS")}</p>
                      </div>

                      <div className="expert-section  institutesearchmainlistingsection">
                        {currentItems?.length > 0 ? (
                          currentItems.map(offer => (

                            <ExpertListCardJSX
                              offerimageUrl={offer?.imageUrl}
                              offerbusinessPhoneNumber={offer.expertSpecializations[0].businessPhoneNumber}
                              offercity={offer.expertSpecializations[0].city}
                              offeremail={offer.email}
                              offerfirstName={offer?.firstName}
                              offerslugUrl={offer?.slugUrl}
                              offerlastName={offer?.lastName}
                              expertSpecializations={offer.expertSpecializations}
                              offerplanName={offer.planName}
                              isparentInstitutionCategory={true}
                              addedAsFree={offer.addedAsFreeExpert}
                              showFreeTag={true}
                              status={offer.status}
                              categoryName={offer.expertSpecializations[0]?.parentInstitutionCategory}
                              offercategoryName={offer.expertSpecializations[0]?.parentInstitutionCategory}
                              offername={offer?.name}
                              offer={offer}
                            // categoryName={cat.categoryName}
                            />

                            //                            
                          ))
                        ) : (
                         <div className="empthy-blog"> <h5>{t("instituteExpertrs.NOEXPERTMSG")}</h5></div>
                        )}
                      </div>


                      {currentItems?.length ? <section className="newpagination"> <Pagination
                        currentPage={currentPage}
                        page={page}
                        allOffersData={expertData}
                        currentItems={currentItems}
                        onPaginationButtonClick={onPaginationButtonClick}
                        itemsPerPage={itemsPerPage}
                      /></section> : null}


                    </div>
                  </div>
                </div>
              </div>

            </section>
            <Footer />
          </section>
          : <Partial />}
      </>
    </>

  );
};

export default MyExpertJsx;
